<script setup lang="ts">
defineProps<{
  label: string;
  value: string | number;
  unit?: string;
  /** Kleine graue Zeile unter der Zahl, z.B. "8 weapons" oder "2 generators". */
  caption?: string;
}>();
</script>

<template>
  <div>
    <p class="!my-0 text-[0.65rem] uppercase tracking-wide text-neutral-500">{{ label }}</p>
    <p class="!my-0 flex items-baseline gap-1.5">
      <span class="text-2xl font-bold text-white">{{ value }}</span>
      <span v-if="unit" class="text-xs font-medium text-neutral-400">{{ unit }}</span>
    </p>
    <p v-if="caption" class="!my-0 text-[0.65rem] text-neutral-600">{{ caption }}</p>
  </div>
</template>
